import React from 'react';

import { Typography, CardMedia } from '@material-ui/core';
import ES from 'components/ExplainString';
import explains from 'data/explains'
// img import
import ic from 'data/shared/ic_logo.png'
import arm from 'data/shared/arm_logo.png'
import GitHubIcon from '@material-ui/icons/GitHub';

import academic from './academic/academic'
import extracurricular from './extracurricular/extracurricular'
import placement from './placement/placement'
import management from './management/management'



const imgHeight = "40px"


export default function coverSummaryGen(props) {

  return [
    {
      category: "Academic",
      img: <img src={ic} height={imgHeight} />,
      content: academic(props)
    },

    {
      category: "Placement",
      img: <img src={arm} height={imgHeight} />,
      content: placement(props)
    },

    {
      category: "Extracurricular",
      content: extracurricular(props)
    },

    {
      category: "Management",
      content: management(props)
    }
  ]
}